//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class V1CasesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    //custom code to format date without localization
    formatDateToLocalISO(date: Date): string {
        const pad = (num: number) => num.toString().padStart(2, '0');
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    /**
     * @return OK
     */
    getCase(caseId: number, cancelToken?: CancelToken): Promise<CaseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/{caseId}";

                    if (caseId === undefined || caseId === null)
                throw new Error("The parameter 'caseId' must be defined.");
                    url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCase(_response);
        });
    }

    protected processGetCase(response: AxiosResponse): Promise<CaseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseDto.fromJS(resultData200);
            return Promise.resolve<CaseDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    updateCase(caseId: string, body?: UpdateCaseDto | undefined, cancelToken?: CancelToken): Promise<CaseDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/{caseId}";

                    if (caseId === undefined || caseId === null)
                throw new Error("The parameter 'caseId' must be defined.");
                    url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
                            url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCase(_response);
        });
    }

    protected processUpdateCase(response: AxiosResponse): Promise<CaseDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = CaseDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<CaseDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDtoApiResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCases(deletedState: DeletedStateEnum, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CaseDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases?";

                            if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCases(_response);
        });
    }

    protected processGetCases(response: AxiosResponse): Promise<CaseDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CaseDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createCase(body?: CreateCaseDto | undefined, cancelToken?: CancelToken): Promise<CaseDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCase(_response);
        });
    }

    protected processCreateCase(response: AxiosResponse): Promise<CaseDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = CaseDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<CaseDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDtoApiResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCasesByDealerId(dealerId: number, deletedState: DeletedStateEnum, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CaseDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/dealer/{dealerId}?";

                    if (dealerId === undefined || dealerId === null)
                throw new Error("The parameter 'dealerId' must be defined.");
                    url_ = url_.replace("{dealerId}", encodeURIComponent("" + dealerId));
                                    if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCasesByDealerId(_response);
        });
    }

    protected processGetCasesByDealerId(response: AxiosResponse): Promise<CaseDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CaseDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getCaseHistory(caseId: number, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, cancelToken?: CancelToken): Promise<CaseHistoryDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/history/{caseId}?";

                    if (caseId === undefined || caseId === null)
                throw new Error("The parameter 'caseId' must be defined.");
                    url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
                                    if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (startDate !== undefined && startDate !== null)
                            url_ += "startDate=" + encodeURIComponent(startDate ? "" + this.formatDateToLocalISO(startDate) : "") + "&";
                            if (endDate !== undefined && endDate !== null)
                            url_ += "endDate=" + encodeURIComponent(endDate ? "" + this.formatDateToLocalISO(endDate) : "") + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseHistory(_response);
        });
    }

    protected processGetCaseHistory(response: AxiosResponse): Promise<CaseHistoryDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseHistoryDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CaseHistoryDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseHistoryDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @return Created
     */
    approveCase(caseId: number, cancelToken?: CancelToken): Promise<CaseDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/approve/{caseId}";

                    if (caseId === undefined || caseId === null)
                throw new Error("The parameter 'caseId' must be defined.");
                    url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveCase(_response);
        });
    }

    protected processApproveCase(response: AxiosResponse): Promise<CaseDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = CaseDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<CaseDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDtoApiResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getCaseCancellationBySubReasonReport(deletedState: DeletedStateEnum, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, cancelToken?: CancelToken): Promise<CaseCancellationReportDto> {
        let url_ = this.baseUrl + "/api/v1/cases/cancellation-report-by-subreason?";

                            if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (startDate !== undefined && startDate !== null)
                            url_ += "startDate=" + encodeURIComponent(startDate ? "" + this.formatDateToLocalISO(startDate) : "") + "&";
                            if (endDate !== undefined && endDate !== null)
                            url_ += "endDate=" + encodeURIComponent(endDate ? "" + this.formatDateToLocalISO(endDate) : "") + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseCancellationBySubReasonReport(_response);
        });
    }

    protected processGetCaseCancellationBySubReasonReport(response: AxiosResponse): Promise<CaseCancellationReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseCancellationReportDto.fromJS(resultData200);
            return Promise.resolve<CaseCancellationReportDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseCancellationReportDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param dealerId (optional) 
     * @param showClosedCases (optional) 
     * @param myCases (optional) 
     * @param closedCasesByUser (optional) 
     * @param closedCasesStartDate (optional) 
     * @param closedCasesUser (optional) 
     * @return OK
     */
    getCasesView(casesViewFilter: CaseViewEnum, deletedState: DeletedStateEnum, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, dealerId?: number | null | undefined, showClosedCases?: boolean | null | undefined, myCases?: boolean | null | undefined, closedCasesByUser?: boolean | null | undefined, closedCasesStartDate?: Date | null | undefined, closedCasesUser?: string | undefined, cancelToken?: CancelToken): Promise<CasesViewDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/cases/view-all?";

                            if (casesViewFilter === undefined || casesViewFilter === null)
                throw new Error("The parameter 'casesViewFilter' must be defined and cannot be null.");
            else
                            url_ += "casesViewFilter=" + encodeURIComponent("" + casesViewFilter) + "&";
                            if (deletedState === undefined || deletedState === null)
                throw new Error("The parameter 'deletedState' must be defined and cannot be null.");
            else
                            url_ += "deletedState=" + encodeURIComponent("" + deletedState) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (dealerId !== undefined && dealerId !== null)
                            url_ += "dealerId=" + encodeURIComponent("" + dealerId) + "&";
                            if (showClosedCases !== undefined && showClosedCases !== null)
                            url_ += "showClosedCases=" + encodeURIComponent("" + showClosedCases) + "&";
                            if (myCases !== undefined && myCases !== null)
                            url_ += "myCases=" + encodeURIComponent("" + myCases) + "&";
                            if (closedCasesByUser !== undefined && closedCasesByUser !== null)
                            url_ += "closedCasesByUser=" + encodeURIComponent("" + closedCasesByUser) + "&";
                            if (closedCasesStartDate !== undefined && closedCasesStartDate !== null)
                            url_ += "closedCasesStartDate=" + encodeURIComponent(closedCasesStartDate ? "" + this.formatDateToLocalISO(closedCasesStartDate) : "") + "&";
                            if (closedCasesUser === null)
                throw new Error("The parameter 'closedCasesUser' cannot be null.");
            else if (closedCasesUser !== undefined)
                            url_ += "closedCasesUser=" + encodeURIComponent("" + closedCasesUser) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCasesView(_response);
        });
    }

    protected processGetCasesView(response: AxiosResponse): Promise<CasesViewDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CasesViewDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CasesViewDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CasesViewDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param isCreateNote (optional) 
     * @param body (optional) 
     * @return Created
     */
    sendCaseNoteEmail(isCreateNote?: boolean | undefined, body?: NoteDto | undefined, cancelToken?: CancelToken): Promise<CaseDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/note-email?";

                            if (isCreateNote === null)
                throw new Error("The parameter 'isCreateNote' cannot be null.");
            else if (isCreateNote !== undefined)
                            url_ += "isCreateNote=" + encodeURIComponent("" + isCreateNote) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendCaseNoteEmail(_response);
        });
    }

    protected processSendCaseNoteEmail(response: AxiosResponse): Promise<CaseDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = CaseDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<CaseDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDtoApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createSmsSetupCases(body?: CreateSmsSetupCaseDto | undefined, cancelToken?: CancelToken): Promise<CreateSmsSetupCaseResponseDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/sms-setup";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSmsSetupCases(_response);
        });
    }

    protected processCreateSmsSetupCases(response: AxiosResponse): Promise<CreateSmsSetupCaseResponseDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = CreateSmsSetupCaseResponseDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<CreateSmsSetupCaseResponseDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateSmsSetupCaseResponseDtoApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateCases(body?: BulkUpdateCases | undefined, cancelToken?: CancelToken): Promise<BulkUpdateCasesBulkApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/bulkcases";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdateCases(_response);
        });
    }

    protected processBulkUpdateCases(response: AxiosResponse): Promise<BulkUpdateCasesBulkApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = BulkUpdateCasesBulkApiResponseDto.fromJS(resultData200);
            return Promise.resolve<BulkUpdateCasesBulkApiResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkUpdateCasesBulkApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    notifyCaseWatchers(caseId: number, body?: BulkIdsDto | undefined, cancelToken?: CancelToken): Promise<CaseDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/notify-watchers/{caseId}";

                    if (caseId === undefined || caseId === null)
                throw new Error("The parameter 'caseId' must be defined.");
                    url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
                            url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotifyCaseWatchers(_response);
        });
    }

    protected processNotifyCaseWatchers(response: AxiosResponse): Promise<CaseDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = CaseDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<CaseDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDtoApiResponseDto>(null as any);
    }

    /**
     * @param caseId (optional) 
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return OK
     */
    getCaseCallHistory(caseId?: number | undefined, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, cancelToken?: CancelToken): Promise<CallHistoryDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/call-history/list?";

                            if (caseId === null)
                throw new Error("The parameter 'caseId' cannot be null.");
            else if (caseId !== undefined)
                            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                            if (startDate !== undefined && startDate !== null)
                            url_ += "startDate=" + encodeURIComponent(startDate ? "" + this.formatDateToLocalISO(startDate) : "") + "&";
                            if (endDate !== undefined && endDate !== null)
                            url_ += "endDate=" + encodeURIComponent(endDate ? "" + this.formatDateToLocalISO(endDate) : "") + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseCallHistory(_response);
        });
    }

    protected processGetCaseCallHistory(response: AxiosResponse): Promise<CallHistoryDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CallHistoryDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CallHistoryDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CallHistoryDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param callHistoryId (optional) 
     * @param caseId (optional) 
     * @return OK
     */
    claimCallHistory(callHistoryId?: number | undefined, caseId?: number | undefined, cancelToken?: CancelToken): Promise<ApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/call-history/claim?";

                            if (callHistoryId === null)
                throw new Error("The parameter 'callHistoryId' cannot be null.");
            else if (callHistoryId !== undefined)
                            url_ += "callHistoryId=" + encodeURIComponent("" + callHistoryId) + "&";
                            if (caseId === null)
                throw new Error("The parameter 'caseId' cannot be null.");
            else if (caseId !== undefined)
                            url_ += "caseId=" + encodeURIComponent("" + caseId) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClaimCallHistory(_response);
        });
    }

    protected processClaimCallHistory(response: AxiosResponse): Promise<ApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = ApiResponseDto.fromJS(resultData200);
            return Promise.resolve<ApiResponseDto>(result200);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    getCaseDomain(caseId: number, cancelToken?: CancelToken): Promise<CaseDomainDto> {
        let url_ = this.baseUrl + "/api/v1/cases/case-domain/{caseId}";

                    if (caseId === undefined || caseId === null)
                throw new Error("The parameter 'caseId' must be defined.");
                    url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
                            url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseDomain(_response);
        });
    }

    protected processGetCaseDomain(response: AxiosResponse): Promise<CaseDomainDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseDomainDto.fromJS(resultData200);
            return Promise.resolve<CaseDomainDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data as string;
            let result404: any = null;
            let resultData404  = JSON.parse(_responseText);
            result404 = ApiResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDomainDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    createCaseDomain(body?: CreateCaseDomainDto | undefined, cancelToken?: CancelToken): Promise<CaseDomainDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/case-domain";

                    url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCaseDomain(_response);
        });
    }

    protected processCreateCaseDomain(response: AxiosResponse): Promise<CaseDomainDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = CaseDomainDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<CaseDomainDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDomainDtoApiResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    updateCaseDomain(caseDomainId: number, body?: UpdateCaseDomainDto | undefined, cancelToken?: CancelToken): Promise<CaseDomainDtoApiResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/case-domain/{caseDomainId}";

                    if (caseDomainId === undefined || caseDomainId === null)
                throw new Error("The parameter 'caseDomainId' must be defined.");
                    url_ = url_.replace("{caseDomainId}", encodeURIComponent("" + caseDomainId));
                            url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCaseDomain(_response);
        });
    }

    protected processUpdateCaseDomain(response: AxiosResponse): Promise<CaseDomainDtoApiResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data as string;
            let result201: any = null;
            let resultData201  = JSON.parse(_responseText);
            result201 = CaseDomainDtoApiResponseDto.fromJS(resultData201);
            return Promise.resolve<CaseDomainDtoApiResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDomainDtoApiResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    apiTest( cancelToken?: CancelToken): Promise<TestDto> {
        let url_ = this.baseUrl + "/api/v1/cases/tests";

                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiTest(_response);
        });
    }

    protected processApiTest(response: AxiosResponse): Promise<TestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = TestDto.fromJS(resultData200);
            return Promise.resolve<TestDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCaseStatuses(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CaseStatusDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/statuses?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseStatuses(_response);
        });
    }

    protected processGetCaseStatuses(response: AxiosResponse): Promise<CaseStatusDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseStatusDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CaseStatusDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseStatusDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCaseSubStatusesByStatusId(caseStatusId: number, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CaseSubStatusDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/sub-statuses/{caseStatusId}?";

                    if (caseStatusId === undefined || caseStatusId === null)
                throw new Error("The parameter 'caseStatusId' must be defined.");
                    url_ = url_.replace("{caseStatusId}", encodeURIComponent("" + caseStatusId));
                                    if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseSubStatusesByStatusId(_response);
        });
    }

    protected processGetCaseSubStatusesByStatusId(response: AxiosResponse): Promise<CaseSubStatusDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseSubStatusDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CaseSubStatusDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseSubStatusDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCaseTypes(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CaseTypeDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/types?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseTypes(_response);
        });
    }

    protected processGetCaseTypes(response: AxiosResponse): Promise<CaseTypeDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseTypeDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CaseTypeDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseTypeDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCaseReasons(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CaseReasonDtoPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/reasons?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseReasons(_response);
        });
    }

    protected processGetCaseReasons(response: AxiosResponse): Promise<CaseReasonDtoPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseReasonDtoPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CaseReasonDtoPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseReasonDtoPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCaseSubReasonsByCaseReasonId(caseReasonId: number, search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CaseSubReasonDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/sub-reasons/{caseReasonId}?";

                    if (caseReasonId === undefined || caseReasonId === null)
                throw new Error("The parameter 'caseReasonId' must be defined.");
                    url_ = url_.replace("{caseReasonId}", encodeURIComponent("" + caseReasonId));
                                    if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseSubReasonsByCaseReasonId(_response);
        });
    }

    protected processGetCaseSubReasonsByCaseReasonId(response: AxiosResponse): Promise<CaseSubReasonDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseSubReasonDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CaseSubReasonDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseSubReasonDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCaseOrigins(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CaseOriginDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/origins?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseOrigins(_response);
        });
    }

    protected processGetCaseOrigins(response: AxiosResponse): Promise<CaseOriginDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CaseOriginDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CaseOriginDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseOriginDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCasePriorities(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CasePriorityDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/priorities?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCasePriorities(_response);
        });
    }

    protected processGetCasePriorities(response: AxiosResponse): Promise<CasePriorityDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CasePriorityDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CasePriorityDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CasePriorityDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCompetitors(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CompetitorDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/competitors?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompetitors(_response);
        });
    }

    protected processGetCompetitors(response: AxiosResponse): Promise<CompetitorDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CompetitorDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CompetitorDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompetitorDtoNotPagedDataResponseDto>(null as any);
    }

    /**
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param includeTotalItems (optional) 
     * @return OK
     */
    getCancellationReasons(search?: string | undefined, sortBy?: string | undefined, sortAscending?: boolean | null | undefined, page?: number | undefined, pageSize?: number | undefined, includeTotalItems?: boolean | null | undefined, cancelToken?: CancelToken): Promise<CancellationReasonDtoNotPagedDataResponseDto> {
        let url_ = this.baseUrl + "/api/v1/cases/cancellationreasons?";

                            if (search === null)
                throw new Error("The parameter 'search' cannot be null.");
            else if (search !== undefined)
                            url_ += "search=" + encodeURIComponent("" + search) + "&";
                            if (sortBy === null)
                throw new Error("The parameter 'sortBy' cannot be null.");
            else if (sortBy !== undefined)
                            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
                            if (sortAscending !== undefined && sortAscending !== null)
                            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
                            if (page === null)
                throw new Error("The parameter 'page' cannot be null.");
            else if (page !== undefined)
                            url_ += "page=" + encodeURIComponent("" + page) + "&";
                            if (pageSize === null)
                throw new Error("The parameter 'pageSize' cannot be null.");
            else if (pageSize !== undefined)
                            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
                            if (includeTotalItems !== undefined && includeTotalItems !== null)
                            url_ += "includeTotalItems=" + encodeURIComponent("" + includeTotalItems) + "&";
                    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCancellationReasons(_response);
        });
    }

    protected processGetCancellationReasons(response: AxiosResponse): Promise<CancellationReasonDtoNotPagedDataResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data as string;
            let result200: any = null;
            let resultData200  = JSON.parse(_responseText);
            result200 = CancellationReasonDtoNotPagedDataResponseDto.fromJS(resultData200);
            return Promise.resolve<CancellationReasonDtoNotPagedDataResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data as string;
            let result400: any = null;
            let resultData400  = JSON.parse(_responseText);
            result400 = ApiResponseDto.fromJS(resultData400);
            return throwException("Bad Request -- Invalid client request.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data as string;
            let result500: any = null;
            let resultData500  = JSON.parse(_responseText);
            result500 = ApiResponseDto.fromJS(resultData500);
            return throwException("Internal error.", status, _responseText, _headers, result500);

        } else if (status === 428) {
            const _responseText = response.data as string;
            let result428: any = null;
            let resultData428  = JSON.parse(_responseText);
            result428 = ApiResponseDto.fromJS(resultData428);
            return throwException("Precondition Required -- two factor authentication is required to access this resource.", status, _responseText, _headers, result428);

        } else if (status === 412) {
            const _responseText = response.data as string;
            let result412: any = null;
            let resultData412  = JSON.parse(_responseText);
            result412 = ApiResponseDto.fromJS(resultData412);
            return throwException("Precondition Failed -- user agreement is not signed.", status, _responseText, _headers, result412);

        } else if (status === 406) {
            const _responseText = response.data as string;
            let result406: any = null;
            let resultData406  = JSON.parse(_responseText);
            result406 = ApiResponseDto.fromJS(resultData406);
            return throwException("NotAcceptable -- Required notifications not acknowledged", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data as string;
            let result401: any = null;
            let resultData401  = JSON.parse(_responseText);
            result401 = ApiResponseDto.fromJS(resultData401);
            return throwException("Unauthorized -- Requires authentication", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data as string;
            let result403: any = null;
            let resultData403  = JSON.parse(_responseText);
            result403 = ApiResponseDto.fromJS(resultData403);
            return throwException("Forbidden -- Requires permissions defined in the description above.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data as string;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CancellationReasonDtoNotPagedDataResponseDto>(null as any);
    }
}

export class ApiResponseDto implements IApiResponseDto {
    id!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): ApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): ApiResponseDto {
        const json = this.toJSON();
        let result = new ApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IApiResponseDto {
    id: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class BulkIdsDto implements IBulkIdsDto {
    ids?: number[] | undefined;

    constructor(data?: IBulkIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): BulkIdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkIdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }

    clone(): BulkIdsDto {
        const json = this.toJSON();
        let result = new BulkIdsDto();
        result.init(json);
        return result;
    }
}

export interface IBulkIdsDto {
    ids?: number[] | undefined;
}

export class BulkUpdateCases implements IBulkUpdateCases {
    caseStatusId?: number | undefined;
    caseSubStatusId?: number | undefined;
    caseReasonId?: number | undefined;
    caseSubReasonId?: number | undefined;
    assignedToUserId?: number | undefined;
    note?: string | undefined;
    deleteCase?: boolean | undefined;
    approveCase?: boolean | undefined;
    private?: boolean | undefined;
    bulkIds?: BulkIdsDto | undefined;
    dealerId?: number | undefined;

    constructor(data?: IBulkUpdateCases) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseStatusId = _data["caseStatusId"];
            this.caseSubStatusId = _data["caseSubStatusId"];
            this.caseReasonId = _data["caseReasonId"];
            this.caseSubReasonId = _data["caseSubReasonId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.note = _data["note"];
            this.deleteCase = _data["deleteCase"];
            this.approveCase = _data["approveCase"];
            this.private = _data["private"];
            this.bulkIds = _data["bulkIds"] ? BulkIdsDto.fromJS(_data["bulkIds"]) : <any>undefined;
            this.dealerId = _data["dealerId"];
        }
    }

    static fromJS(data: any): BulkUpdateCases {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateCases();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseStatusId"] = this.caseStatusId;
        data["caseSubStatusId"] = this.caseSubStatusId;
        data["caseReasonId"] = this.caseReasonId;
        data["caseSubReasonId"] = this.caseSubReasonId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["note"] = this.note;
        data["deleteCase"] = this.deleteCase;
        data["approveCase"] = this.approveCase;
        data["private"] = this.private;
        data["bulkIds"] = this.bulkIds ? this.bulkIds.toJSON() : <any>undefined;
        data["dealerId"] = this.dealerId;
        return data;
    }

    clone(): BulkUpdateCases {
        const json = this.toJSON();
        let result = new BulkUpdateCases();
        result.init(json);
        return result;
    }
}

export interface IBulkUpdateCases {
    caseStatusId?: number | undefined;
    caseSubStatusId?: number | undefined;
    caseReasonId?: number | undefined;
    caseSubReasonId?: number | undefined;
    assignedToUserId?: number | undefined;
    note?: string | undefined;
    deleteCase?: boolean | undefined;
    approveCase?: boolean | undefined;
    private?: boolean | undefined;
    bulkIds?: BulkIdsDto | undefined;
    dealerId?: number | undefined;
}

export class BulkUpdateCasesApiResponseDto implements IBulkUpdateCasesApiResponseDto {
    id!: number;
    payload?: BulkUpdateCases | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: IBulkUpdateCasesApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? BulkUpdateCases.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): BulkUpdateCasesApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateCasesApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): BulkUpdateCasesApiResponseDto {
        const json = this.toJSON();
        let result = new BulkUpdateCasesApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IBulkUpdateCasesApiResponseDto {
    id: number;
    payload?: BulkUpdateCases | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class BulkUpdateCasesBulkApiResponseDto implements IBulkUpdateCasesBulkApiResponseDto {
    statusCode!: HttpStatusCode;
    readonly success!: boolean;
    readonly errors?: string[] | undefined;
    readonly status?: string | undefined;
    responses?: BulkUpdateCasesApiResponseDto[] | undefined;

    constructor(data?: IBulkUpdateCasesBulkApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            (<any>this).success = _data["success"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
            (<any>this).status = _data["status"];
            if (Array.isArray(_data["responses"])) {
                this.responses = [] as any;
                for (let item of _data["responses"])
                    this.responses!.push(BulkUpdateCasesApiResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkUpdateCasesBulkApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkUpdateCasesBulkApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["success"] = this.success;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["status"] = this.status;
        if (Array.isArray(this.responses)) {
            data["responses"] = [];
            for (let item of this.responses)
                data["responses"].push(item.toJSON());
        }
        return data;
    }

    clone(): BulkUpdateCasesBulkApiResponseDto {
        const json = this.toJSON();
        let result = new BulkUpdateCasesBulkApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface IBulkUpdateCasesBulkApiResponseDto {
    statusCode: HttpStatusCode;
    success: boolean;
    errors?: string[] | undefined;
    status?: string | undefined;
    responses?: BulkUpdateCasesApiResponseDto[] | undefined;
}

export class CallHistoryDto implements ICallHistoryDto {
    callHistoryId!: number;
    caseId?: number | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    startTime!: Date;
    type?: string | undefined;

    constructor(data?: ICallHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callHistoryId = _data["callHistoryId"];
            this.caseId = _data["caseId"];
            this.userName = _data["userName"];
            this.phoneNumber = _data["phoneNumber"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): CallHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["callHistoryId"] = this.callHistoryId;
        data["caseId"] = this.caseId;
        data["userName"] = this.userName;
        data["phoneNumber"] = this.phoneNumber;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data;
    }

    clone(): CallHistoryDto {
        const json = this.toJSON();
        let result = new CallHistoryDto();
        result.init(json);
        return result;
    }
}

export interface ICallHistoryDto {
    callHistoryId: number;
    caseId?: number | undefined;
    userName?: string | undefined;
    phoneNumber?: string | undefined;
    startTime: Date;
    type?: string | undefined;
}

export class CallHistoryDtoPagedDataResponseDto implements ICallHistoryDtoPagedDataResponseDto {
    data!: CallHistoryDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICallHistoryDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CallHistoryDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CallHistoryDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CallHistoryDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CallHistoryDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CallHistoryDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICallHistoryDtoPagedDataResponseDto {
    data: CallHistoryDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CancellationReasonDto implements ICancellationReasonDto {
    cancellationReasonId!: number;
    cancellationReason1?: string | undefined;
    sortOrder?: number | undefined;

    constructor(data?: ICancellationReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.cancellationReason1 = _data["cancellationReason1"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CancellationReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["cancellationReason1"] = this.cancellationReason1;
        data["sortOrder"] = this.sortOrder;
        return data;
    }

    clone(): CancellationReasonDto {
        const json = this.toJSON();
        let result = new CancellationReasonDto();
        result.init(json);
        return result;
    }
}

export interface ICancellationReasonDto {
    cancellationReasonId: number;
    cancellationReason1?: string | undefined;
    sortOrder?: number | undefined;
}

export class CancellationReasonDtoNotPagedDataResponseDto implements ICancellationReasonDtoNotPagedDataResponseDto {
    data!: CancellationReasonDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICancellationReasonDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CancellationReasonDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CancellationReasonDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancellationReasonDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CancellationReasonDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CancellationReasonDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICancellationReasonDtoNotPagedDataResponseDto {
    data: CancellationReasonDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseCancellationReportDto implements ICaseCancellationReportDto {
    totalsByType?: CaseCancellationReportValuesNotPagedDataResponseDto | undefined;
    data?: CasesViewDtoNotPagedDataResponseDto | undefined;

    constructor(data?: ICaseCancellationReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalsByType = _data["totalsByType"] ? CaseCancellationReportValuesNotPagedDataResponseDto.fromJS(_data["totalsByType"]) : <any>undefined;
            this.data = _data["data"] ? CasesViewDtoNotPagedDataResponseDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseCancellationReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseCancellationReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalsByType"] = this.totalsByType ? this.totalsByType.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }

    clone(): CaseCancellationReportDto {
        const json = this.toJSON();
        let result = new CaseCancellationReportDto();
        result.init(json);
        return result;
    }
}

export interface ICaseCancellationReportDto {
    totalsByType?: CaseCancellationReportValuesNotPagedDataResponseDto | undefined;
    data?: CasesViewDtoNotPagedDataResponseDto | undefined;
}

export class CaseCancellationReportValues implements ICaseCancellationReportValues {
    cancellationTypeKey?: string | undefined;
    countValue!: number;

    constructor(data?: ICaseCancellationReportValues) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cancellationTypeKey = _data["cancellationTypeKey"];
            this.countValue = _data["countValue"];
        }
    }

    static fromJS(data: any): CaseCancellationReportValues {
        data = typeof data === 'object' ? data : {};
        let result = new CaseCancellationReportValues();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cancellationTypeKey"] = this.cancellationTypeKey;
        data["countValue"] = this.countValue;
        return data;
    }

    clone(): CaseCancellationReportValues {
        const json = this.toJSON();
        let result = new CaseCancellationReportValues();
        result.init(json);
        return result;
    }
}

export interface ICaseCancellationReportValues {
    cancellationTypeKey?: string | undefined;
    countValue: number;
}

export class CaseCancellationReportValuesNotPagedDataResponseDto implements ICaseCancellationReportValuesNotPagedDataResponseDto {
    data!: CaseCancellationReportValues[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseCancellationReportValuesNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaseCancellationReportValues.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseCancellationReportValuesNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseCancellationReportValuesNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseCancellationReportValuesNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CaseCancellationReportValuesNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseCancellationReportValuesNotPagedDataResponseDto {
    data: CaseCancellationReportValues[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseDomainDto implements ICaseDomainDto {
    caseDomainId!: number;
    caseId!: number;
    previousNameServer?: string | undefined;
    previousNameServer2?: string | undefined;
    previousNameServer3?: string | undefined;
    previousMx?: string | undefined;
    previousMx2?: string | undefined;
    previousArecord?: string | undefined;
    previousWhoIs?: string | undefined;

    constructor(data?: ICaseDomainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseDomainId = _data["caseDomainId"];
            this.caseId = _data["caseId"];
            this.previousNameServer = _data["previousNameServer"];
            this.previousNameServer2 = _data["previousNameServer2"];
            this.previousNameServer3 = _data["previousNameServer3"];
            this.previousMx = _data["previousMx"];
            this.previousMx2 = _data["previousMx2"];
            this.previousArecord = _data["previousArecord"];
            this.previousWhoIs = _data["previousWhoIs"];
        }
    }

    static fromJS(data: any): CaseDomainDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDomainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseDomainId"] = this.caseDomainId;
        data["caseId"] = this.caseId;
        data["previousNameServer"] = this.previousNameServer;
        data["previousNameServer2"] = this.previousNameServer2;
        data["previousNameServer3"] = this.previousNameServer3;
        data["previousMx"] = this.previousMx;
        data["previousMx2"] = this.previousMx2;
        data["previousArecord"] = this.previousArecord;
        data["previousWhoIs"] = this.previousWhoIs;
        return data;
    }

    clone(): CaseDomainDto {
        const json = this.toJSON();
        let result = new CaseDomainDto();
        result.init(json);
        return result;
    }
}

export interface ICaseDomainDto {
    caseDomainId: number;
    caseId: number;
    previousNameServer?: string | undefined;
    previousNameServer2?: string | undefined;
    previousNameServer3?: string | undefined;
    previousMx?: string | undefined;
    previousMx2?: string | undefined;
    previousArecord?: string | undefined;
    previousWhoIs?: string | undefined;
}

export class CaseDomainDtoApiResponseDto implements ICaseDomainDtoApiResponseDto {
    id!: number;
    payload?: CaseDomainDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseDomainDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? CaseDomainDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseDomainDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDomainDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseDomainDtoApiResponseDto {
        const json = this.toJSON();
        let result = new CaseDomainDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseDomainDtoApiResponseDto {
    id: number;
    payload?: CaseDomainDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseDto implements ICaseDto {
    caseId!: number;
    dealerId?: number | undefined;
    assignedToUserId?: number | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    caseStatusId!: number;
    caseSubStatusId?: number | undefined;
    caseTypeId!: number;
    caseReasonId!: number;
    caseSubReasonId?: number | undefined;
    caseOriginId!: number;
    casePriorityId!: number;
    dealerContactId?: number | undefined;
    createdById!: number;
    createdDate!: Date;
    lastModifiedById!: number;
    lastModifiedDate!: Date;
    closedDate?: Date | undefined;
    dueDate?: Date | undefined;
    age?: string | undefined;
    dealerContactName?: string | undefined;
    accountOwnerId?: number | undefined;
    timeZoneId?: number | undefined;
    productName?: string | undefined;
    owner?: string | undefined;
    status?: string | undefined;
    dealer?: DealerDto | undefined;
    approvedById?: number | undefined;
    approvedDate?: Date | undefined;
    cancellationReasonId?: number | undefined;
    competitorId?: number | undefined;
    caseDomain?: CaseDomainDto | undefined;

    constructor(data?: ICaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.dealerId = _data["dealerId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.caseStatusId = _data["caseStatusId"];
            this.caseSubStatusId = _data["caseSubStatusId"];
            this.caseTypeId = _data["caseTypeId"];
            this.caseReasonId = _data["caseReasonId"];
            this.caseSubReasonId = _data["caseSubReasonId"];
            this.caseOriginId = _data["caseOriginId"];
            this.casePriorityId = _data["casePriorityId"];
            this.dealerContactId = _data["dealerContactId"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedById = _data["lastModifiedById"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.age = _data["age"];
            this.dealerContactName = _data["dealerContactName"];
            this.accountOwnerId = _data["accountOwnerId"];
            this.timeZoneId = _data["timeZoneId"];
            this.productName = _data["productName"];
            this.owner = _data["owner"];
            this.status = _data["status"];
            this.dealer = _data["dealer"] ? DealerDto.fromJS(_data["dealer"]) : <any>undefined;
            this.approvedById = _data["approvedById"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.competitorId = _data["competitorId"];
            this.caseDomain = _data["caseDomain"] ? CaseDomainDto.fromJS(_data["caseDomain"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["dealerId"] = this.dealerId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["caseStatusId"] = this.caseStatusId;
        data["caseSubStatusId"] = this.caseSubStatusId;
        data["caseTypeId"] = this.caseTypeId;
        data["caseReasonId"] = this.caseReasonId;
        data["caseSubReasonId"] = this.caseSubReasonId;
        data["caseOriginId"] = this.caseOriginId;
        data["casePriorityId"] = this.casePriorityId;
        data["dealerContactId"] = this.dealerContactId;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedById"] = this.lastModifiedById;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["age"] = this.age;
        data["dealerContactName"] = this.dealerContactName;
        data["accountOwnerId"] = this.accountOwnerId;
        data["timeZoneId"] = this.timeZoneId;
        data["productName"] = this.productName;
        data["owner"] = this.owner;
        data["status"] = this.status;
        data["dealer"] = this.dealer ? this.dealer.toJSON() : <any>undefined;
        data["approvedById"] = this.approvedById;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["competitorId"] = this.competitorId;
        data["caseDomain"] = this.caseDomain ? this.caseDomain.toJSON() : <any>undefined;
        return data;
    }

    clone(): CaseDto {
        const json = this.toJSON();
        let result = new CaseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseDto {
    caseId: number;
    dealerId?: number | undefined;
    assignedToUserId?: number | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    caseStatusId: number;
    caseSubStatusId?: number | undefined;
    caseTypeId: number;
    caseReasonId: number;
    caseSubReasonId?: number | undefined;
    caseOriginId: number;
    casePriorityId: number;
    dealerContactId?: number | undefined;
    createdById: number;
    createdDate: Date;
    lastModifiedById: number;
    lastModifiedDate: Date;
    closedDate?: Date | undefined;
    dueDate?: Date | undefined;
    age?: string | undefined;
    dealerContactName?: string | undefined;
    accountOwnerId?: number | undefined;
    timeZoneId?: number | undefined;
    productName?: string | undefined;
    owner?: string | undefined;
    status?: string | undefined;
    dealer?: DealerDto | undefined;
    approvedById?: number | undefined;
    approvedDate?: Date | undefined;
    cancellationReasonId?: number | undefined;
    competitorId?: number | undefined;
    caseDomain?: CaseDomainDto | undefined;
}

export class CaseDtoApiResponseDto implements ICaseDtoApiResponseDto {
    id!: number;
    payload?: CaseDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? CaseDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseDtoApiResponseDto {
        const json = this.toJSON();
        let result = new CaseDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseDtoApiResponseDto {
    id: number;
    payload?: CaseDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseDtoPagedDataResponseDto implements ICaseDtoPagedDataResponseDto {
    data!: CaseDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaseDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CaseDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseDtoPagedDataResponseDto {
    data: CaseDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseHistoryDto implements ICaseHistoryDto {
    caseHistoryId!: number;
    caseId!: number;
    changes?: string | undefined;
    changeMadeById!: number;
    changeMadeByName?: string | undefined;
    createdDate!: Date;

    constructor(data?: ICaseHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseHistoryId = _data["caseHistoryId"];
            this.caseId = _data["caseId"];
            this.changes = _data["changes"];
            this.changeMadeById = _data["changeMadeById"];
            this.changeMadeByName = _data["changeMadeByName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseHistoryId"] = this.caseHistoryId;
        data["caseId"] = this.caseId;
        data["changes"] = this.changes;
        data["changeMadeById"] = this.changeMadeById;
        data["changeMadeByName"] = this.changeMadeByName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CaseHistoryDto {
        const json = this.toJSON();
        let result = new CaseHistoryDto();
        result.init(json);
        return result;
    }
}

export interface ICaseHistoryDto {
    caseHistoryId: number;
    caseId: number;
    changes?: string | undefined;
    changeMadeById: number;
    changeMadeByName?: string | undefined;
    createdDate: Date;
}

export class CaseHistoryDtoPagedDataResponseDto implements ICaseHistoryDtoPagedDataResponseDto {
    data!: CaseHistoryDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseHistoryDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaseHistoryDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseHistoryDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseHistoryDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseHistoryDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CaseHistoryDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseHistoryDtoPagedDataResponseDto {
    data: CaseHistoryDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseOriginDto implements ICaseOriginDto {
    caseOriginId!: number;
    caseOrigin1?: string | undefined;

    constructor(data?: ICaseOriginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseOriginId = _data["caseOriginId"];
            this.caseOrigin1 = _data["caseOrigin1"];
        }
    }

    static fromJS(data: any): CaseOriginDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseOriginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseOriginId"] = this.caseOriginId;
        data["caseOrigin1"] = this.caseOrigin1;
        return data;
    }

    clone(): CaseOriginDto {
        const json = this.toJSON();
        let result = new CaseOriginDto();
        result.init(json);
        return result;
    }
}

export interface ICaseOriginDto {
    caseOriginId: number;
    caseOrigin1?: string | undefined;
}

export class CaseOriginDtoNotPagedDataResponseDto implements ICaseOriginDtoNotPagedDataResponseDto {
    data!: CaseOriginDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseOriginDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaseOriginDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseOriginDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseOriginDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseOriginDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CaseOriginDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseOriginDtoNotPagedDataResponseDto {
    data: CaseOriginDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CasePriorityDto implements ICasePriorityDto {
    casePriorityId!: number;
    casePriority1?: string | undefined;

    constructor(data?: ICasePriorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.casePriorityId = _data["casePriorityId"];
            this.casePriority1 = _data["casePriority1"];
        }
    }

    static fromJS(data: any): CasePriorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CasePriorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["casePriorityId"] = this.casePriorityId;
        data["casePriority1"] = this.casePriority1;
        return data;
    }

    clone(): CasePriorityDto {
        const json = this.toJSON();
        let result = new CasePriorityDto();
        result.init(json);
        return result;
    }
}

export interface ICasePriorityDto {
    casePriorityId: number;
    casePriority1?: string | undefined;
}

export class CasePriorityDtoNotPagedDataResponseDto implements ICasePriorityDtoNotPagedDataResponseDto {
    data!: CasePriorityDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICasePriorityDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CasePriorityDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CasePriorityDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CasePriorityDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CasePriorityDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CasePriorityDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICasePriorityDtoNotPagedDataResponseDto {
    data: CasePriorityDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseReasonDto implements ICaseReasonDto {
    caseReasonId!: number;
    caseReason1?: string | undefined;

    constructor(data?: ICaseReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseReasonId = _data["caseReasonId"];
            this.caseReason1 = _data["caseReason1"];
        }
    }

    static fromJS(data: any): CaseReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseReasonId"] = this.caseReasonId;
        data["caseReason1"] = this.caseReason1;
        return data;
    }

    clone(): CaseReasonDto {
        const json = this.toJSON();
        let result = new CaseReasonDto();
        result.init(json);
        return result;
    }
}

export interface ICaseReasonDto {
    caseReasonId: number;
    caseReason1?: string | undefined;
}

export class CaseReasonDtoPagedDataResponseDto implements ICaseReasonDtoPagedDataResponseDto {
    data!: CaseReasonDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseReasonDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaseReasonDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseReasonDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseReasonDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseReasonDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CaseReasonDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseReasonDtoPagedDataResponseDto {
    data: CaseReasonDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseStatusDto implements ICaseStatusDto {
    caseStatusId!: number;
    caseStatus1?: string | undefined;

    constructor(data?: ICaseStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseStatusId = _data["caseStatusId"];
            this.caseStatus1 = _data["caseStatus1"];
        }
    }

    static fromJS(data: any): CaseStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseStatusId"] = this.caseStatusId;
        data["caseStatus1"] = this.caseStatus1;
        return data;
    }

    clone(): CaseStatusDto {
        const json = this.toJSON();
        let result = new CaseStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICaseStatusDto {
    caseStatusId: number;
    caseStatus1?: string | undefined;
}

export class CaseStatusDtoPagedDataResponseDto implements ICaseStatusDtoPagedDataResponseDto {
    data!: CaseStatusDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseStatusDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaseStatusDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseStatusDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseStatusDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseStatusDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CaseStatusDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseStatusDtoPagedDataResponseDto {
    data: CaseStatusDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseSubReasonDto implements ICaseSubReasonDto {
    caseSubReasonId!: number;
    parentCaseReasonId!: number;
    caseSubReason1?: string | undefined;

    constructor(data?: ICaseSubReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseSubReasonId = _data["caseSubReasonId"];
            this.parentCaseReasonId = _data["parentCaseReasonId"];
            this.caseSubReason1 = _data["caseSubReason1"];
        }
    }

    static fromJS(data: any): CaseSubReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseSubReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseSubReasonId"] = this.caseSubReasonId;
        data["parentCaseReasonId"] = this.parentCaseReasonId;
        data["caseSubReason1"] = this.caseSubReason1;
        return data;
    }

    clone(): CaseSubReasonDto {
        const json = this.toJSON();
        let result = new CaseSubReasonDto();
        result.init(json);
        return result;
    }
}

export interface ICaseSubReasonDto {
    caseSubReasonId: number;
    parentCaseReasonId: number;
    caseSubReason1?: string | undefined;
}

export class CaseSubReasonDtoNotPagedDataResponseDto implements ICaseSubReasonDtoNotPagedDataResponseDto {
    data!: CaseSubReasonDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseSubReasonDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaseSubReasonDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseSubReasonDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseSubReasonDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseSubReasonDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CaseSubReasonDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseSubReasonDtoNotPagedDataResponseDto {
    data: CaseSubReasonDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseSubStatusDto implements ICaseSubStatusDto {
    caseSubStatusId!: number;
    parentCaseStatusId!: number;
    caseSubStatus1?: string | undefined;

    constructor(data?: ICaseSubStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseSubStatusId = _data["caseSubStatusId"];
            this.parentCaseStatusId = _data["parentCaseStatusId"];
            this.caseSubStatus1 = _data["caseSubStatus1"];
        }
    }

    static fromJS(data: any): CaseSubStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseSubStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseSubStatusId"] = this.caseSubStatusId;
        data["parentCaseStatusId"] = this.parentCaseStatusId;
        data["caseSubStatus1"] = this.caseSubStatus1;
        return data;
    }

    clone(): CaseSubStatusDto {
        const json = this.toJSON();
        let result = new CaseSubStatusDto();
        result.init(json);
        return result;
    }
}

export interface ICaseSubStatusDto {
    caseSubStatusId: number;
    parentCaseStatusId: number;
    caseSubStatus1?: string | undefined;
}

export class CaseSubStatusDtoPagedDataResponseDto implements ICaseSubStatusDtoPagedDataResponseDto {
    data!: CaseSubStatusDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseSubStatusDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaseSubStatusDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseSubStatusDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseSubStatusDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseSubStatusDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CaseSubStatusDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseSubStatusDtoPagedDataResponseDto {
    data: CaseSubStatusDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CaseTypeDto implements ICaseTypeDto {
    caseTypeId!: number;
    caseType1?: string | undefined;

    constructor(data?: ICaseTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseTypeId = _data["caseTypeId"];
            this.caseType1 = _data["caseType1"];
        }
    }

    static fromJS(data: any): CaseTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseTypeId"] = this.caseTypeId;
        data["caseType1"] = this.caseType1;
        return data;
    }

    clone(): CaseTypeDto {
        const json = this.toJSON();
        let result = new CaseTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICaseTypeDto {
    caseTypeId: number;
    caseType1?: string | undefined;
}

export class CaseTypeDtoPagedDataResponseDto implements ICaseTypeDtoPagedDataResponseDto {
    data!: CaseTypeDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICaseTypeDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CaseTypeDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CaseTypeDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseTypeDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CaseTypeDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CaseTypeDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICaseTypeDtoPagedDataResponseDto {
    data: CaseTypeDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export enum CaseViewEnum {
    AllCases = "AllCases",
    DBAccessCases = "DBAccessCases",
    CSCases = "CSCases",
    SalesExecutive = "SalesExecutive",
    WebCases = "WebCases",
    SEOCases = "SEOCases",
    DataCases = "DataCases",
    CSCampaigns = "CSCampaigns",
    CSEscalations = "CSEscalations",
    SalesCases = "SalesCases",
    RetentionCases = "RetentionCases",
    DomainCases = "DomainCases",
    DomainManager = "DomainManager",
    QACases = "QACases",
    AccountingCases = "AccountingCases",
    WebSetupCases = "WebSetupCases",
    LazarusCases = "LazarusCases",
    FrazerOneCases = "FrazerOneCases",
}

export class CasesViewDto implements ICasesViewDto {
    caseId!: number;
    dealerId?: number | undefined;
    dealerName?: string | undefined;
    assignedToUserId?: number | undefined;
    assignedToUser?: string | undefined;
    subject?: string | undefined;
    caseStatusId!: number;
    caseStatus?: string | undefined;
    caseSubStatusId?: number | undefined;
    caseSubStatus?: string | undefined;
    caseTypeId!: number;
    caseType?: string | undefined;
    caseReasonId!: number;
    caseReason?: string | undefined;
    caseSubReasonId?: number | undefined;
    caseSubReason?: string | undefined;
    casePriorityId!: number;
    casePriority?: string | undefined;
    dealerContactName?: string | undefined;
    dueDate?: Date | undefined;
    productCost?: number | undefined;
    age?: number | undefined;
    server?: string | undefined;
    createdDate!: Date;
    lastModifiedDate!: Date;
    dealerStatusId?: number | undefined;
    dealerStatus?: string | undefined;
    timeZoneId?: number | undefined;
    timeZone?: string | undefined;
    roleName?: string | undefined;
    roleId?: number | undefined;
    note?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    approvedById?: number | undefined;
    approvedByName?: string | undefined;
    approvedByFirstName?: string | undefined;
    approvedByLastName?: string | undefined;
    openInvoiceTotal?: number | undefined;
    pastDueInvoiceTotal?: number | undefined;
    invoiceTypeName?: string | undefined;
    phone?: string | undefined;
    competitorName?: string | undefined;
    cancellationReasonName?: string | undefined;
    billingEffectiveDate?: Date | undefined;
    createdById?: number | undefined;
    createdByName?: string | undefined;
    contractEndDate?: Date | undefined;

    constructor(data?: ICasesViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.assignedToUser = _data["assignedToUser"];
            this.subject = _data["subject"];
            this.caseStatusId = _data["caseStatusId"];
            this.caseStatus = _data["caseStatus"];
            this.caseSubStatusId = _data["caseSubStatusId"];
            this.caseSubStatus = _data["caseSubStatus"];
            this.caseTypeId = _data["caseTypeId"];
            this.caseType = _data["caseType"];
            this.caseReasonId = _data["caseReasonId"];
            this.caseReason = _data["caseReason"];
            this.caseSubReasonId = _data["caseSubReasonId"];
            this.caseSubReason = _data["caseSubReason"];
            this.casePriorityId = _data["casePriorityId"];
            this.casePriority = _data["casePriority"];
            this.dealerContactName = _data["dealerContactName"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.productCost = _data["productCost"];
            this.age = _data["age"];
            this.server = _data["server"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.dealerStatusId = _data["dealerStatusId"];
            this.dealerStatus = _data["dealerStatus"];
            this.timeZoneId = _data["timeZoneId"];
            this.timeZone = _data["timeZone"];
            this.roleName = _data["roleName"];
            this.roleId = _data["roleId"];
            this.note = _data["note"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.approvedById = _data["approvedById"];
            this.approvedByName = _data["approvedByName"];
            this.approvedByFirstName = _data["approvedByFirstName"];
            this.approvedByLastName = _data["approvedByLastName"];
            this.openInvoiceTotal = _data["openInvoiceTotal"];
            this.pastDueInvoiceTotal = _data["pastDueInvoiceTotal"];
            this.invoiceTypeName = _data["invoiceTypeName"];
            this.phone = _data["phone"];
            this.competitorName = _data["competitorName"];
            this.cancellationReasonName = _data["cancellationReasonName"];
            this.billingEffectiveDate = _data["billingEffectiveDate"] ? new Date(_data["billingEffectiveDate"].toString()) : <any>undefined;
            this.createdById = _data["createdById"];
            this.createdByName = _data["createdByName"];
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CasesViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CasesViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["assignedToUserId"] = this.assignedToUserId;
        data["assignedToUser"] = this.assignedToUser;
        data["subject"] = this.subject;
        data["caseStatusId"] = this.caseStatusId;
        data["caseStatus"] = this.caseStatus;
        data["caseSubStatusId"] = this.caseSubStatusId;
        data["caseSubStatus"] = this.caseSubStatus;
        data["caseTypeId"] = this.caseTypeId;
        data["caseType"] = this.caseType;
        data["caseReasonId"] = this.caseReasonId;
        data["caseReason"] = this.caseReason;
        data["caseSubReasonId"] = this.caseSubReasonId;
        data["caseSubReason"] = this.caseSubReason;
        data["casePriorityId"] = this.casePriorityId;
        data["casePriority"] = this.casePriority;
        data["dealerContactName"] = this.dealerContactName;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["productCost"] = this.productCost;
        data["age"] = this.age;
        data["server"] = this.server;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["dealerStatusId"] = this.dealerStatusId;
        data["dealerStatus"] = this.dealerStatus;
        data["timeZoneId"] = this.timeZoneId;
        data["timeZone"] = this.timeZone;
        data["roleName"] = this.roleName;
        data["roleId"] = this.roleId;
        data["note"] = this.note;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["approvedById"] = this.approvedById;
        data["approvedByName"] = this.approvedByName;
        data["approvedByFirstName"] = this.approvedByFirstName;
        data["approvedByLastName"] = this.approvedByLastName;
        data["openInvoiceTotal"] = this.openInvoiceTotal;
        data["pastDueInvoiceTotal"] = this.pastDueInvoiceTotal;
        data["invoiceTypeName"] = this.invoiceTypeName;
        data["phone"] = this.phone;
        data["competitorName"] = this.competitorName;
        data["cancellationReasonName"] = this.cancellationReasonName;
        data["billingEffectiveDate"] = this.billingEffectiveDate ? this.billingEffectiveDate.toISOString() : <any>undefined;
        data["createdById"] = this.createdById;
        data["createdByName"] = this.createdByName;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CasesViewDto {
        const json = this.toJSON();
        let result = new CasesViewDto();
        result.init(json);
        return result;
    }
}

export interface ICasesViewDto {
    caseId: number;
    dealerId?: number | undefined;
    dealerName?: string | undefined;
    assignedToUserId?: number | undefined;
    assignedToUser?: string | undefined;
    subject?: string | undefined;
    caseStatusId: number;
    caseStatus?: string | undefined;
    caseSubStatusId?: number | undefined;
    caseSubStatus?: string | undefined;
    caseTypeId: number;
    caseType?: string | undefined;
    caseReasonId: number;
    caseReason?: string | undefined;
    caseSubReasonId?: number | undefined;
    caseSubReason?: string | undefined;
    casePriorityId: number;
    casePriority?: string | undefined;
    dealerContactName?: string | undefined;
    dueDate?: Date | undefined;
    productCost?: number | undefined;
    age?: number | undefined;
    server?: string | undefined;
    createdDate: Date;
    lastModifiedDate: Date;
    dealerStatusId?: number | undefined;
    dealerStatus?: string | undefined;
    timeZoneId?: number | undefined;
    timeZone?: string | undefined;
    roleName?: string | undefined;
    roleId?: number | undefined;
    note?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    approvedById?: number | undefined;
    approvedByName?: string | undefined;
    approvedByFirstName?: string | undefined;
    approvedByLastName?: string | undefined;
    openInvoiceTotal?: number | undefined;
    pastDueInvoiceTotal?: number | undefined;
    invoiceTypeName?: string | undefined;
    phone?: string | undefined;
    competitorName?: string | undefined;
    cancellationReasonName?: string | undefined;
    billingEffectiveDate?: Date | undefined;
    createdById?: number | undefined;
    createdByName?: string | undefined;
    contractEndDate?: Date | undefined;
}

export class CasesViewDtoNotPagedDataResponseDto implements ICasesViewDtoNotPagedDataResponseDto {
    data!: CasesViewDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICasesViewDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CasesViewDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CasesViewDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CasesViewDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CasesViewDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CasesViewDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICasesViewDtoNotPagedDataResponseDto {
    data: CasesViewDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CasesViewDtoPagedDataResponseDto implements ICasesViewDtoPagedDataResponseDto {
    data!: CasesViewDto[];
    page!: number;
    pageSize!: number;
    maxPageSize!: number;
    minPageSize!: number;
    readonly skip!: number;
    totalItems?: number | undefined;
    readonly totalPages!: number;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICasesViewDtoPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CasesViewDto.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.maxPageSize = _data["maxPageSize"];
            this.minPageSize = _data["minPageSize"];
            (<any>this).skip = _data["skip"];
            this.totalItems = _data["totalItems"];
            (<any>this).totalPages = _data["totalPages"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CasesViewDtoPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CasesViewDtoPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["maxPageSize"] = this.maxPageSize;
        data["minPageSize"] = this.minPageSize;
        data["skip"] = this.skip;
        data["totalItems"] = this.totalItems;
        data["totalPages"] = this.totalPages;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CasesViewDtoPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CasesViewDtoPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICasesViewDtoPagedDataResponseDto {
    data: CasesViewDto[];
    page: number;
    pageSize: number;
    maxPageSize: number;
    minPageSize: number;
    skip: number;
    totalItems?: number | undefined;
    totalPages: number;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CompetitorDto implements ICompetitorDto {
    competitorId!: number;
    competitorName?: string | undefined;
    websiteAddress?: string | undefined;
    classified!: boolean;

    constructor(data?: ICompetitorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitorId = _data["competitorId"];
            this.competitorName = _data["competitorName"];
            this.websiteAddress = _data["websiteAddress"];
            this.classified = _data["classified"];
        }
    }

    static fromJS(data: any): CompetitorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitorId"] = this.competitorId;
        data["competitorName"] = this.competitorName;
        data["websiteAddress"] = this.websiteAddress;
        data["classified"] = this.classified;
        return data;
    }

    clone(): CompetitorDto {
        const json = this.toJSON();
        let result = new CompetitorDto();
        result.init(json);
        return result;
    }
}

export interface ICompetitorDto {
    competitorId: number;
    competitorName?: string | undefined;
    websiteAddress?: string | undefined;
    classified: boolean;
}

export class CompetitorDtoNotPagedDataResponseDto implements ICompetitorDtoNotPagedDataResponseDto {
    data!: CompetitorDto[];
    totalItems?: number | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICompetitorDtoNotPagedDataResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CompetitorDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CompetitorDtoNotPagedDataResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitorDtoNotPagedDataResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CompetitorDtoNotPagedDataResponseDto {
        const json = this.toJSON();
        let result = new CompetitorDtoNotPagedDataResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICompetitorDtoNotPagedDataResponseDto {
    data: CompetitorDto[];
    totalItems?: number | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class CreateCaseDomainDto implements ICreateCaseDomainDto {
    caseId!: number;
    previousNameServer?: string | undefined;
    previousNameServer2?: string | undefined;
    previousNameServer3?: string | undefined;
    previousMx?: string | undefined;
    previousMx2?: string | undefined;
    previousArecord?: string | undefined;
    previousWhoIs?: string | undefined;

    constructor(data?: ICreateCaseDomainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.previousNameServer = _data["previousNameServer"];
            this.previousNameServer2 = _data["previousNameServer2"];
            this.previousNameServer3 = _data["previousNameServer3"];
            this.previousMx = _data["previousMx"];
            this.previousMx2 = _data["previousMx2"];
            this.previousArecord = _data["previousArecord"];
            this.previousWhoIs = _data["previousWhoIs"];
        }
    }

    static fromJS(data: any): CreateCaseDomainDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaseDomainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["previousNameServer"] = this.previousNameServer;
        data["previousNameServer2"] = this.previousNameServer2;
        data["previousNameServer3"] = this.previousNameServer3;
        data["previousMx"] = this.previousMx;
        data["previousMx2"] = this.previousMx2;
        data["previousArecord"] = this.previousArecord;
        data["previousWhoIs"] = this.previousWhoIs;
        return data;
    }

    clone(): CreateCaseDomainDto {
        const json = this.toJSON();
        let result = new CreateCaseDomainDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCaseDomainDto {
    caseId: number;
    previousNameServer?: string | undefined;
    previousNameServer2?: string | undefined;
    previousNameServer3?: string | undefined;
    previousMx?: string | undefined;
    previousMx2?: string | undefined;
    previousArecord?: string | undefined;
    previousWhoIs?: string | undefined;
}

export class CreateCaseDto implements ICreateCaseDto {
    dealerId?: number | undefined;
    assignedToUserId?: number | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    caseStatusId!: number;
    caseSubStatusId?: number | undefined;
    caseTypeId!: number;
    caseReasonId!: number;
    caseSubReasonId?: number | undefined;
    caseOriginId!: number;
    casePriorityId!: number;
    dealerContactId?: number | undefined;
    note?: string | undefined;
    closedDate?: Date | undefined;
    approvedById?: number | undefined;
    approvedDate?: Date | undefined;
    cancellationReasonId?: number | undefined;
    competitorId?: number | undefined;

    constructor(data?: ICreateCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.caseStatusId = _data["caseStatusId"];
            this.caseSubStatusId = _data["caseSubStatusId"];
            this.caseTypeId = _data["caseTypeId"];
            this.caseReasonId = _data["caseReasonId"];
            this.caseSubReasonId = _data["caseSubReasonId"];
            this.caseOriginId = _data["caseOriginId"];
            this.casePriorityId = _data["casePriorityId"];
            this.dealerContactId = _data["dealerContactId"];
            this.note = _data["note"];
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : <any>undefined;
            this.approvedById = _data["approvedById"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.competitorId = _data["competitorId"];
        }
    }

    static fromJS(data: any): CreateCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["caseStatusId"] = this.caseStatusId;
        data["caseSubStatusId"] = this.caseSubStatusId;
        data["caseTypeId"] = this.caseTypeId;
        data["caseReasonId"] = this.caseReasonId;
        data["caseSubReasonId"] = this.caseSubReasonId;
        data["caseOriginId"] = this.caseOriginId;
        data["casePriorityId"] = this.casePriorityId;
        data["dealerContactId"] = this.dealerContactId;
        data["note"] = this.note;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : <any>undefined;
        data["approvedById"] = this.approvedById;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["competitorId"] = this.competitorId;
        return data;
    }

    clone(): CreateCaseDto {
        const json = this.toJSON();
        let result = new CreateCaseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCaseDto {
    dealerId?: number | undefined;
    assignedToUserId?: number | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    caseStatusId: number;
    caseSubStatusId?: number | undefined;
    caseTypeId: number;
    caseReasonId: number;
    caseSubReasonId?: number | undefined;
    caseOriginId: number;
    casePriorityId: number;
    dealerContactId?: number | undefined;
    note?: string | undefined;
    closedDate?: Date | undefined;
    approvedById?: number | undefined;
    approvedDate?: Date | undefined;
    cancellationReasonId?: number | undefined;
    competitorId?: number | undefined;
}

export class CreateSmsSetupCaseDto implements ICreateSmsSetupCaseDto {
    dealerId!: number;
    accountType!: SmsAccountTypeEnum;
    twilioStatus?: string | undefined;

    constructor(data?: ICreateSmsSetupCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealerId = _data["dealerId"];
            this.accountType = _data["accountType"];
            this.twilioStatus = _data["twilioStatus"];
        }
    }

    static fromJS(data: any): CreateSmsSetupCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSmsSetupCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealerId"] = this.dealerId;
        data["accountType"] = this.accountType;
        data["twilioStatus"] = this.twilioStatus;
        return data;
    }

    clone(): CreateSmsSetupCaseDto {
        const json = this.toJSON();
        let result = new CreateSmsSetupCaseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSmsSetupCaseDto {
    dealerId: number;
    accountType: SmsAccountTypeEnum;
    twilioStatus?: string | undefined;
}

export class CreateSmsSetupCaseResponseDto implements ICreateSmsSetupCaseResponseDto {
    createdCaseIds?: number[] | undefined;

    constructor(data?: ICreateSmsSetupCaseResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["createdCaseIds"])) {
                this.createdCaseIds = [] as any;
                for (let item of _data["createdCaseIds"])
                    this.createdCaseIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSmsSetupCaseResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSmsSetupCaseResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.createdCaseIds)) {
            data["createdCaseIds"] = [];
            for (let item of this.createdCaseIds)
                data["createdCaseIds"].push(item);
        }
        return data;
    }

    clone(): CreateSmsSetupCaseResponseDto {
        const json = this.toJSON();
        let result = new CreateSmsSetupCaseResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSmsSetupCaseResponseDto {
    createdCaseIds?: number[] | undefined;
}

export class CreateSmsSetupCaseResponseDtoApiResponseDto implements ICreateSmsSetupCaseResponseDtoApiResponseDto {
    id!: number;
    payload?: CreateSmsSetupCaseResponseDto | undefined;
    statusCode!: HttpStatusCode;
    errors!: string[];
    readonly success!: boolean;

    constructor(data?: ICreateSmsSetupCaseResponseDtoApiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.payload = _data["payload"] ? CreateSmsSetupCaseResponseDto.fromJS(_data["payload"]) : <any>undefined;
            this.statusCode = _data["statusCode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): CreateSmsSetupCaseResponseDtoApiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSmsSetupCaseResponseDtoApiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["payload"] = this.payload ? this.payload.toJSON() : <any>undefined;
        data["statusCode"] = this.statusCode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["success"] = this.success;
        return data;
    }

    clone(): CreateSmsSetupCaseResponseDtoApiResponseDto {
        const json = this.toJSON();
        let result = new CreateSmsSetupCaseResponseDtoApiResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSmsSetupCaseResponseDtoApiResponseDto {
    id: number;
    payload?: CreateSmsSetupCaseResponseDto | undefined;
    statusCode: HttpStatusCode;
    errors: string[];
    success: boolean;
}

export class DealerDto implements IDealerDto {
    active?: boolean | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    bodyShopPhone?: string | undefined;
    termsAndConditions?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    dealerGroupId?: number | undefined;
    dealerId!: number;
    dealerName?: string | undefined;
    dealerNumber?: string | undefined;
    dealerLicenseNumber?: string | undefined;
    dealershipWebsite?: string | undefined;
    server?: string | undefined;
    guid?: string | undefined;
    deleted!: boolean;
    detailingPhone?: string | undefined;
    enableDeletedReason?: boolean | undefined;
    fax?: string | undefined;
    franchise?: boolean | undefined;
    homePageUpdateTime?: Date | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    partsPhone?: string | undefined;
    phone?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactName?: string | undefined;
    principalEmail?: string | undefined;
    principalName?: string | undefined;
    secondaryPhone?: string | undefined;
    servicePhone?: string | undefined;
    state?: string | undefined;
    websiteDisplayName?: string | undefined;
    websiteStyle?: string | undefined;
    misc1?: string | undefined;
    misc2?: string | undefined;
    federalIdNumber?: string | undefined;
    zip?: string | undefined;
    readonly formattedName?: string | undefined;
    buyHerePayHere!: boolean;
    cldisabled?: boolean | undefined;
    contractEndDate?: Date | undefined;
    readonly guidWebsite?: string | undefined;

    constructor(data?: IDealerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.active = _data["active"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.bodyShopPhone = _data["bodyShopPhone"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.city = _data["city"];
            this.county = _data["county"];
            this.dealerGroupId = _data["dealerGroupId"];
            this.dealerId = _data["dealerId"];
            this.dealerName = _data["dealerName"];
            this.dealerNumber = _data["dealerNumber"];
            this.dealerLicenseNumber = _data["dealerLicenseNumber"];
            this.dealershipWebsite = _data["dealershipWebsite"];
            this.server = _data["server"];
            this.guid = _data["guid"];
            this.deleted = _data["deleted"];
            this.detailingPhone = _data["detailingPhone"];
            this.enableDeletedReason = _data["enableDeletedReason"];
            this.fax = _data["fax"];
            this.franchise = _data["franchise"];
            this.homePageUpdateTime = _data["homePageUpdateTime"] ? new Date(_data["homePageUpdateTime"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.partsPhone = _data["partsPhone"];
            this.phone = _data["phone"];
            this.primaryContactEmail = _data["primaryContactEmail"];
            this.primaryContactName = _data["primaryContactName"];
            this.principalEmail = _data["principalEmail"];
            this.principalName = _data["principalName"];
            this.secondaryPhone = _data["secondaryPhone"];
            this.servicePhone = _data["servicePhone"];
            this.state = _data["state"];
            this.websiteDisplayName = _data["websiteDisplayName"];
            this.websiteStyle = _data["websiteStyle"];
            this.misc1 = _data["misc1"];
            this.misc2 = _data["misc2"];
            this.federalIdNumber = _data["federalIdNumber"];
            this.zip = _data["zip"];
            (<any>this).formattedName = _data["formattedName"];
            this.buyHerePayHere = _data["buyHerePayHere"];
            this.cldisabled = _data["cldisabled"];
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
            (<any>this).guidWebsite = _data["guidWebsite"];
        }
    }

    static fromJS(data: any): DealerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["active"] = this.active;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["bodyShopPhone"] = this.bodyShopPhone;
        data["termsAndConditions"] = this.termsAndConditions;
        data["city"] = this.city;
        data["county"] = this.county;
        data["dealerGroupId"] = this.dealerGroupId;
        data["dealerId"] = this.dealerId;
        data["dealerName"] = this.dealerName;
        data["dealerNumber"] = this.dealerNumber;
        data["dealerLicenseNumber"] = this.dealerLicenseNumber;
        data["dealershipWebsite"] = this.dealershipWebsite;
        data["server"] = this.server;
        data["guid"] = this.guid;
        data["deleted"] = this.deleted;
        data["detailingPhone"] = this.detailingPhone;
        data["enableDeletedReason"] = this.enableDeletedReason;
        data["fax"] = this.fax;
        data["franchise"] = this.franchise;
        data["homePageUpdateTime"] = this.homePageUpdateTime ? this.homePageUpdateTime.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["partsPhone"] = this.partsPhone;
        data["phone"] = this.phone;
        data["primaryContactEmail"] = this.primaryContactEmail;
        data["primaryContactName"] = this.primaryContactName;
        data["principalEmail"] = this.principalEmail;
        data["principalName"] = this.principalName;
        data["secondaryPhone"] = this.secondaryPhone;
        data["servicePhone"] = this.servicePhone;
        data["state"] = this.state;
        data["websiteDisplayName"] = this.websiteDisplayName;
        data["websiteStyle"] = this.websiteStyle;
        data["misc1"] = this.misc1;
        data["misc2"] = this.misc2;
        data["federalIdNumber"] = this.federalIdNumber;
        data["zip"] = this.zip;
        data["formattedName"] = this.formattedName;
        data["buyHerePayHere"] = this.buyHerePayHere;
        data["cldisabled"] = this.cldisabled;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data["guidWebsite"] = this.guidWebsite;
        return data;
    }

    clone(): DealerDto {
        const json = this.toJSON();
        let result = new DealerDto();
        result.init(json);
        return result;
    }
}

export interface IDealerDto {
    active?: boolean | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    bodyShopPhone?: string | undefined;
    termsAndConditions?: string | undefined;
    city?: string | undefined;
    county?: string | undefined;
    dealerGroupId?: number | undefined;
    dealerId: number;
    dealerName?: string | undefined;
    dealerNumber?: string | undefined;
    dealerLicenseNumber?: string | undefined;
    dealershipWebsite?: string | undefined;
    server?: string | undefined;
    guid?: string | undefined;
    deleted: boolean;
    detailingPhone?: string | undefined;
    enableDeletedReason?: boolean | undefined;
    fax?: string | undefined;
    franchise?: boolean | undefined;
    homePageUpdateTime?: Date | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    partsPhone?: string | undefined;
    phone?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactName?: string | undefined;
    principalEmail?: string | undefined;
    principalName?: string | undefined;
    secondaryPhone?: string | undefined;
    servicePhone?: string | undefined;
    state?: string | undefined;
    websiteDisplayName?: string | undefined;
    websiteStyle?: string | undefined;
    misc1?: string | undefined;
    misc2?: string | undefined;
    federalIdNumber?: string | undefined;
    zip?: string | undefined;
    formattedName?: string | undefined;
    buyHerePayHere: boolean;
    cldisabled?: boolean | undefined;
    contractEndDate?: Date | undefined;
    guidWebsite?: string | undefined;
}

export enum DeletedStateEnum {
    Undefined = "Undefined",
    Active = "Active",
    Deleted = "Deleted",
    Both = "Both",
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class NoteDto implements INoteDto {
    sfnoteId!: number;
    dealerId?: number | undefined;
    caseId?: number | undefined;
    prospectId?: number | undefined;
    taskId?: number | undefined;
    developmentId?: number | undefined;
    importerId?: number | undefined;
    exporterSfId?: number | undefined;
    dealerContactId?: number | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;
    note?: string | undefined;
    private!: boolean;
    createdById!: number;
    createdDate!: Date;
    lastModifiedById!: number;
    lastModifiedDate!: Date;
    noteType!: NoteTypeEnum;

    constructor(data?: INoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sfnoteId = _data["sfnoteId"];
            this.dealerId = _data["dealerId"];
            this.caseId = _data["caseId"];
            this.prospectId = _data["prospectId"];
            this.taskId = _data["taskId"];
            this.developmentId = _data["developmentId"];
            this.importerId = _data["importerId"];
            this.exporterSfId = _data["exporterSfId"];
            this.dealerContactId = _data["dealerContactId"];
            this.createdByName = _data["createdByName"];
            this.lastModifiedByName = _data["lastModifiedByName"];
            this.note = _data["note"];
            this.private = _data["private"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedById = _data["lastModifiedById"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.noteType = _data["noteType"];
        }
    }

    static fromJS(data: any): NoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sfnoteId"] = this.sfnoteId;
        data["dealerId"] = this.dealerId;
        data["caseId"] = this.caseId;
        data["prospectId"] = this.prospectId;
        data["taskId"] = this.taskId;
        data["developmentId"] = this.developmentId;
        data["importerId"] = this.importerId;
        data["exporterSfId"] = this.exporterSfId;
        data["dealerContactId"] = this.dealerContactId;
        data["createdByName"] = this.createdByName;
        data["lastModifiedByName"] = this.lastModifiedByName;
        data["note"] = this.note;
        data["private"] = this.private;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedById"] = this.lastModifiedById;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["noteType"] = this.noteType;
        return data;
    }

    clone(): NoteDto {
        const json = this.toJSON();
        let result = new NoteDto();
        result.init(json);
        return result;
    }
}

export interface INoteDto {
    sfnoteId: number;
    dealerId?: number | undefined;
    caseId?: number | undefined;
    prospectId?: number | undefined;
    taskId?: number | undefined;
    developmentId?: number | undefined;
    importerId?: number | undefined;
    exporterSfId?: number | undefined;
    dealerContactId?: number | undefined;
    createdByName?: string | undefined;
    lastModifiedByName?: string | undefined;
    note?: string | undefined;
    private: boolean;
    createdById: number;
    createdDate: Date;
    lastModifiedById: number;
    lastModifiedDate: Date;
    noteType: NoteTypeEnum;
}

export enum NoteTypeEnum {
    Dealer = "Dealer",
    Case = "Case",
    Task = "Task",
    Lead = "Lead",
    Development = "Development",
    Importer = "Importer",
    Exporter = "Exporter",
    DealerContact = "DealerContact",
}

export enum SmsAccountTypeEnum {
    Hosted = "Hosted",
    TollFree = "TollFree",
}

export class TestDto implements ITestDto {
    prop?: string | undefined;

    constructor(data?: ITestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prop = _data["prop"];
        }
    }

    static fromJS(data: any): TestDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prop"] = this.prop;
        return data;
    }

    clone(): TestDto {
        const json = this.toJSON();
        let result = new TestDto();
        result.init(json);
        return result;
    }
}

export interface ITestDto {
    prop?: string | undefined;
}

export class UpdateCaseDomainDto implements IUpdateCaseDomainDto {
    previousNameServer?: string | undefined;
    previousNameServer2?: string | undefined;
    previousNameServer3?: string | undefined;
    previousMx?: string | undefined;
    previousMx2?: string | undefined;
    previousArecord?: string | undefined;
    previousWhoIs?: string | undefined;

    constructor(data?: IUpdateCaseDomainDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousNameServer = _data["previousNameServer"];
            this.previousNameServer2 = _data["previousNameServer2"];
            this.previousNameServer3 = _data["previousNameServer3"];
            this.previousMx = _data["previousMx"];
            this.previousMx2 = _data["previousMx2"];
            this.previousArecord = _data["previousArecord"];
            this.previousWhoIs = _data["previousWhoIs"];
        }
    }

    static fromJS(data: any): UpdateCaseDomainDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseDomainDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousNameServer"] = this.previousNameServer;
        data["previousNameServer2"] = this.previousNameServer2;
        data["previousNameServer3"] = this.previousNameServer3;
        data["previousMx"] = this.previousMx;
        data["previousMx2"] = this.previousMx2;
        data["previousArecord"] = this.previousArecord;
        data["previousWhoIs"] = this.previousWhoIs;
        return data;
    }

    clone(): UpdateCaseDomainDto {
        const json = this.toJSON();
        let result = new UpdateCaseDomainDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseDomainDto {
    previousNameServer?: string | undefined;
    previousNameServer2?: string | undefined;
    previousNameServer3?: string | undefined;
    previousMx?: string | undefined;
    previousMx2?: string | undefined;
    previousArecord?: string | undefined;
    previousWhoIs?: string | undefined;
}

export class UpdateCaseDto implements IUpdateCaseDto {
    caseId!: number;
    dealerId?: number | undefined;
    assignedToUserId?: number | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    caseStatusId!: number;
    caseSubStatusId?: number | undefined;
    caseTypeId!: number;
    caseReasonId!: number;
    caseSubReasonId?: number | undefined;
    caseOriginId!: number;
    casePriorityId!: number;
    dealerContactId?: number | undefined;
    note?: string | undefined;
    closedDate?: Date | undefined;
    approvedById?: number | undefined;
    approvedDate?: Date | undefined;
    cancellationReasonId?: number | undefined;
    competitorId?: number | undefined;

    constructor(data?: IUpdateCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.dealerId = _data["dealerId"];
            this.assignedToUserId = _data["assignedToUserId"];
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.caseStatusId = _data["caseStatusId"];
            this.caseSubStatusId = _data["caseSubStatusId"];
            this.caseTypeId = _data["caseTypeId"];
            this.caseReasonId = _data["caseReasonId"];
            this.caseSubReasonId = _data["caseSubReasonId"];
            this.caseOriginId = _data["caseOriginId"];
            this.casePriorityId = _data["casePriorityId"];
            this.dealerContactId = _data["dealerContactId"];
            this.note = _data["note"];
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : <any>undefined;
            this.approvedById = _data["approvedById"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.cancellationReasonId = _data["cancellationReasonId"];
            this.competitorId = _data["competitorId"];
        }
    }

    static fromJS(data: any): UpdateCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["dealerId"] = this.dealerId;
        data["assignedToUserId"] = this.assignedToUserId;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["caseStatusId"] = this.caseStatusId;
        data["caseSubStatusId"] = this.caseSubStatusId;
        data["caseTypeId"] = this.caseTypeId;
        data["caseReasonId"] = this.caseReasonId;
        data["caseSubReasonId"] = this.caseSubReasonId;
        data["caseOriginId"] = this.caseOriginId;
        data["casePriorityId"] = this.casePriorityId;
        data["dealerContactId"] = this.dealerContactId;
        data["note"] = this.note;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : <any>undefined;
        data["approvedById"] = this.approvedById;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["cancellationReasonId"] = this.cancellationReasonId;
        data["competitorId"] = this.competitorId;
        return data;
    }

    clone(): UpdateCaseDto {
        const json = this.toJSON();
        let result = new UpdateCaseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaseDto {
    caseId: number;
    dealerId?: number | undefined;
    assignedToUserId?: number | undefined;
    subject?: string | undefined;
    description?: string | undefined;
    dueDate?: Date | undefined;
    caseStatusId: number;
    caseSubStatusId?: number | undefined;
    caseTypeId: number;
    caseReasonId: number;
    caseSubReasonId?: number | undefined;
    caseOriginId: number;
    casePriorityId: number;
    dealerContactId?: number | undefined;
    note?: string | undefined;
    closedDate?: Date | undefined;
    approvedById?: number | undefined;
    approvedDate?: Date | undefined;
    cancellationReasonId?: number | undefined;
    competitorId?: number | undefined;
}

export class V1ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isV1ApiException = true;

    static isV1ApiException(obj: any): obj is V1ApiException {
        return obj.isV1ApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new V1ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}